import {
  Box,
  BoxProps,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import { useCallback, useState } from 'react';
import { MemberBookingTable } from '../../../../../../components/MemberBookingTable';

export const GuestDetailsTabs = (props: BoxProps): JSX.Element => {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChanges = useCallback((index: number) => {
    setTabIndex(index);
  }, []);

  return (
    <Box {...props}>
      <Tabs
        index={tabIndex}
        isLazy
        onChange={handleTabChanges}
        variant="enclosed-colored"
      >
        <TabList>
          <Tab>Bookings</Tab>
        </TabList>

        <TabPanels mt="4">
          <TabPanel>
            <MemberBookingTable />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};
